import axios from "axios";

axios.defaults.withCredentials = true;

export default {
  async getGestionnaires() {
    const gestionnaires = await axios
      .get(process.env.VUE_APP_BACKEND_API_URL + process.env.VUE_APP_URL_DRHS)
      .catch(function (error) {
        if (error.response) {
          console.log(error.response);
          console.log(error.response.data);
        }
      });
    //console.log(gestionnaires.data);
    return gestionnaires.data;
  },
};
